// extracted by mini-css-extract-plugin
export default {"divContainer":"Loader_divContainer__AC95V"};